var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.primaryCountry
    ? _c(
        "FormGroup",
        { attrs: { title: _vm.stateProvinceSelectTitle, errors: _vm.errors } },
        [
          _c("StateProvinceSelect", {
            attrs: {
              multiple: _vm.multiple,
              countries: _vm.countries,
              disabled: _vm.disabled,
              searchable: "",
            },
            model: {
              value: _vm.stateOption,
              callback: function ($$v) {
                _vm.stateOption = $$v
              },
              expression: "stateOption",
            },
          }),
        ],
        1
      )
    : _c("FormGroup", {
        attrs: {
          title: "Region",
          placeholder: "Enter region",
          disabled: _vm.disabled,
        },
        on: { enter: _vm.handleEnter },
        model: {
          value: _vm.region,
          callback: function ($$v) {
            _vm.region = $$v
          },
          expression: "region",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }